import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Text } from "@mantine/core";
import { IconArrowLeft, IconHome } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { Colors } from "../../Lib/data";
import "./styles.scss";

const Error404: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-code">
          <Text
            fw={900}
            fz={180}
            style={{
              color: Colors.PurplePrimary,
              lineHeight: 1,
              textShadow: `0 0 40px ${Colors.PurplePrimary}40`,
            }}
          >
            404
          </Text>
        </div>

        <div className="error-message">
          <Text fw={700} fz={32} c="dark.7" mb={16}>
            {t("error.404.title")}
          </Text>
          <Text fz="lg" c="dimmed" mb={32} maw={500} ta="center">
            {t("error.404.message")}
          </Text>
        </div>

        <div className="error-actions">
          <Button
            leftSection={<IconArrowLeft size={20} />}
            variant="light"
            size="lg"
            radius="xl"
            onClick={() => navigate(-1)}
            className="back-button"
          >
            {t("error.404.goBack")}
          </Button>
          <Button
            leftSection={<IconHome size={20} />}
            size="lg"
            radius="xl"
            onClick={() => navigate("/d")}
            className="home-button"
          >
            {t("error.404.goHome")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Error404;
